export default [
  {
    text: "国网江苏省电力有限公司信息公开指南",
    url: "/pdf/messageGkzn/国网江苏省电力有限公司信息公开指南.pdf",
  },
];
